export const USER_TYPES = [
    { name: 'Suppliers',  value: 'suppliers', id:'data-qa-suppliers'}
];